/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentQueryExecutedBy extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AwsSsmDocumentQueryExecutedBy");
    }

    getFixupPrototypeFunction() { return AwsSsmDocumentQueryExecutedBy.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentQueryExecutedBy>): AwsSsmDocumentQueryExecutedBy {
        let obj = Object.assign(new AwsSsmDocumentQueryExecutedBy(), model);
        AwsSsmDocumentQueryExecutedBy.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentQueryExecutedBy>): AwsSsmDocumentQueryExecutedBy {
        if (!model) return null;
        return AwsSsmDocumentQueryExecutedBy.newInstance(<AwsSsmDocumentQueryExecutedBy> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentQueryExecutedBy) {
        if (!obj) return;

        models.AwsSsmDocumentQueryExecutedBy.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentQueryExecutedBy): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmDocumentQueryExecutedBy.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * IAM ARN of the user who executed the document
     */
    executed_by: Array<string>;

}
